module.exports = __webpack_public_path__ + "img/measurement_info_back_upper_thigh_right.159a1f02.jpg";